import HttpService from '../http/http.service';
import { GenericViewModel, GitCommitRequest, ModulesViewModel, UpdateModuleConfigRequest } from '@/types/apiServerContract';

const API_PATH = 'git/';

export class GitAPI {
    public static async ResetChanges(): Promise<GenericViewModel<string>> {
        return HttpService.Post<GenericViewModel<string>>(API_PATH + 'ResetChanges');
    }

    public static async CommitChanges(request: GitCommitRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'CommitChanges', request);
    }

    public static async GetUncommitedChanges(): Promise<GenericViewModel<string>> {
        return HttpService.Get<GenericViewModel<string>>(API_PATH + 'GetUncommitedChanges');
    }

    public static async GetModules(): Promise<ModulesViewModel> {
        return HttpService.Get<ModulesViewModel>(API_PATH + 'GetModules');
    }

    public static async InstallModule(moduleId: number): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'InstallModule?moduleId=' + moduleId);
    }

    public static async RemoveModule(moduleId: number): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'RemoveModule?moduleId=' + moduleId);
    }

    public static async UpdateModule(moduleId: number): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateModule?moduleId=' + moduleId);
    }

    public static async GetModuleConfig(moduleId: number): Promise<GenericViewModel<string>> {
        return HttpService.Get<GenericViewModel<string>>(API_PATH + 'GetModuleConfig?moduleId=' + moduleId);
    }

    public static async UpdateModuleConfig(request: UpdateModuleConfigRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateModuleConfig', request);
    }

    public static async ResetModuleConfig(moduleId: number): Promise<GenericViewModel<string>> {
        return HttpService.Post<GenericViewModel<string>>(API_PATH + 'ResetModuleConfig?moduleId=' + moduleId);
    }
}
